import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ConfigProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import themes from '@iso/config/theme/theme.config';
import { locales } from '@iso/config/locales';

export default function AppProvider({ children }) {
  const [locale, setlocale] = useState('en');
  const { themeName } = useSelector(
    (state) => state.ThemeSwitcher.changeThemes
  );

  useEffect(() => {
    const languageCode = navigator.language.substring(0, 2);

    var countryCode = 'US';
    axios
      .get('https://ipapi.co/json/')
      .then((response) => {
        countryCode = response.data.country_code;
        const localeString = String(languageCode + '-' + countryCode);

        const localeCode = locales.find((item) => {
          const code = item.replace('-', '').toLowerCase();
          const derivedcode = localeString.replace('-', '').toLowerCase();
          if (code === derivedcode) {
            return true;
          } else {
            return false;
          }
        });

        if (localeCode) setlocale(localeCode);
      })
      .catch((error) => {
        setlocale('en-US');
      });
  }, []);

  return (
    <IntlProvider locale={locale}>
      <ThemeProvider theme={themes[themeName]}>{children}</ThemeProvider>
    </IntlProvider>
  );
}
